import {
    IconGauge,
    IconMenu2, IconMenuDeep,
    IconHome,
    IconWallet,
    IconReport,
    IconLogout,
    IconUser,
    IconZeroConfig,
    IconCashBanknote,
    IconLogs
} from '@tabler/icons-react';
import {Group, ScrollArea, Button } from '@mantine/core';
// import { LinksGroup } from '../NavbarLinksGroup/NavbarLinksGroup';
// import { UserButton } from '../UserButton/UserButton';
// import Logo from '../Assets/Defaultlogo.png';
import './Sidenavbar.css';
import { Menu, Image } from 'antd';
import { useState } from 'react';
import Logo from '../Assets/Defaultlogo.png'
// import Wtowdistributor from '../Components/Distributor/Balance/wtowretailer';
import Adminhome from '../Components/Admin/Home';
import Admindashboard from '../Components/Admin/Dashboard';
import Fundrequest from '../Components/Admin/Balance_and_fund/Fundrequest';
import Revertrequest from '../Components/Admin/Balance_and_fund/Revertrequest';
import Selfwallettopup from '../Components/Admin/Balance_and_fund/Selfwallettopup';
import Wallettowallettransfer from '../Components/Admin/Balance_and_fund/Wallettowallettransfer';
import Adminselfledger from '../Components/Admin/Reports/Selfledger';
import Usersledger from '../Components/Admin/Users/Usersledger';
import Masterdist from '../Components/Admin/Users/Masterdist';
import Distributor from '../Components/Admin/Users/Distributor';
import Retailer from '../Components/Admin/Users/Retailer';
import Swapuser from '../Components/Admin/Users/Swapuser';
import AdminBanks from '../Components/Admin/Banks/Adminbanks';
import Portalconfig from '../Components/Admin/Config_and_updates/Portalconfig';
import Publishupdates from '../Components/Admin/Config_and_updates/Publishupdates';
import Loginlogs from '../Components/Admin/Logs/Loginlogs';
import Fundlogs from '../Components/Admin/Logs/Fundlogs';
import Revertlogs from '../Components/Admin/Logs/Revertlogs';
import Subadmin from '../Components/Admin/Config_and_updates/Subadmin';

const mockdata = [
    {
        key: "1",
        label: "Home",
        icon: <IconHome size={18} />,
    },

    {
        key: "2",
        label: "Dashboard",
        icon: <IconGauge size={18} />,
    },
    {
        key: "3",
        label: "Balance & Funds",
        icon: <IconWallet size={18} />,
        children: [
            {
                key: "3-main",
                label: "Fund Requests",
            },
            {
                key: "3-1",
                label: "Revert Request",
            },
            {
                key: "3-2",
                label: "Refund Request",
            },
            {
                key: "3-3",
                label: "Wallet top-up (Self)",
            },
            {
                key: "3-4",
                label: "Wallet to Wallet Transfer",
            },
        ],
    },
    {
        key: "4",
        label: "Users Management",
        icon: <IconUser size={18} />,
        children: [
            {
                key: "4-main",
                label: "Master Distributor",
            },
            {
                key: "4-1",
                label: "Distributor",
            },
            {
                key: "4-2",
                label: "Retailer",
            },
            {
                key: "4-3",
                label: "User Swap",
            },
            {
                key: "4-4",
                label: "Commission Splits",
            },
            {
                key: "4-5",
                label: "User Ledger",
            },
        ],
    },
    {
        key: "5",
        label: "Reports",
        icon: <IconReport size={18} />,
        children: [
            {
                key: "5-main",
                label: "Ledger Reports",
            },
            {
                key: "5-1",
                label: "Transaction Reports",
            },
            {
                key: "5-2",
                label: "Transaction Summary Reports",
            },
            {
                key: "5-3",
                label: "Commission & TDS Reports",
            },
            {
                key: "5-4",
                label: "Fees & Charges Reports",
            },
        ],
    },
    {
        key: "6",
        label: "Banks",
        icon: <IconCashBanknote size={18} />,
        children: [
            {
                key: "6-main",
                label: "Admin Banks",
            },
            {
                key: "6-1",
                label: "Beneficiary Banks",
            },
            // {
            //     key: "3-2",
            //     label: "Refund Request",
            // },
            // {
            //     key: "3-2",
            //     label: "Wallet top-up",
            // },
            // {
            //     key: "3-4",
            //     label: "Wallet to Wallet Transfer",
            // },
        ],
    },
    {
        key: "7",
        label: "Config & Updates",
        icon: <IconZeroConfig size={18} />,
        children: [
            {
                key: "7-main",
                label: "API Configuration",
            },
            {
                key: "7-1",
                label: "Portal Configuration",
            },
            {
                key: "7-2",
                label: "Updates",
            },
            {
                key: "7-3",
                label: "Sub Admin",
            },
            // {
            //     key: "3-4",
            //     label: "Wallet to Wallet Transfer",
            // },
        ],
    },
    {
        key: "8",
        label: "Logs",
        icon: <IconLogs size={18} />,
        children: [
            {
                key: "8-main",
                label: "Login Logs",
            },
            {
                key: "8-1",
                label: "Fund Logs",
            },
            {
                key: "8-2",
                label: "Revert Logs",
            },
            // {
            //     key: "3-2",
            //     label: "Wallet top-up",
            // },
            // {
            //     key: "3-4",
            //     label: "Wallet to Wallet Transfer",
            // },
        ],
    },
];

export function NavbarNestedadmin() {
    // const links = mockdata.map((item) => <LinksGroup {...item} key={item.label} />);
    const [selectedKey, setSelectedKey] = useState("1"); // Default selected key
    const [collapsed, setCollapsed] = useState(false);

    const renderSelectedItem = (key) => {
        switch (key) {
            case "1":
                return <Adminhome Headername={'Home'} />;
            // return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Dashboard Headername={"Dashboard"} />
            //     : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
            case "2":
                return <Admindashboard Headername={'Dashboard'} />;
            // case "3":
            //   return <Topinrequest Headername={'Top In Requests'}/>;
            case "3-main":
                return <Fundrequest Headername={'Fund Requests'} />;
            case "3-1":
                return <Revertrequest Headername={'Revert Requests'} />;
            case "3-2":
                return;
            // return <Fundtoretailertransfer Headername={'Fund to Retailer Transfer'} />;
            case "3-3":
                return <Selfwallettopup Headername={'Self Wallet Top-up'} />;
            case "3-4":
                return <Wallettowallettransfer Headername={'Wallet to Wallet Transfer'} />;
            // case "4":
            //   return;
            case "4-main":
                return <Masterdist Headername={'Master Distributors Profile'} />;
            case "4-1":
                return <Distributor Headername={'Distributors Profile'} />;
            case "4-2":
                return <Retailer Headername={'Retailers Profile'} />;
            case "4-3":
                return <Swapuser Headername={'Swap User'} />;
            case "4-4": // fees and charges
                return;
            case "4-5": // fees and charges
                return <Usersledger Headername={'Users Ledger'} />;
            case "5-main":
                return <Adminselfledger Headername={'Self Ledger'} />
            case "6-main":
                return <AdminBanks Headername={'Admin Banks'} />
            case "7-1":
                return <Portalconfig Headername={'Portal Configuration'} />
            case "7-2":
                return <Publishupdates Headername={'Updates'} />
            case "7-3":
                return <Subadmin Headername={'Sub Admin'} />
            case "8-main":
                return <Loginlogs Headername={'Login Logs'} />;
            case "8-1":
                return <Fundlogs Headername={'Fund Logs'} />;
            case "8-2":
                return <Revertlogs Headername={'Revert Logs'} />;

            //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Buyerlists Headername={"Buyer List"} />
            //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
            // case "sm-1":
            //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Invoicehistory Headername={"Invoice History"} />
            //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
            // case "3-main":
            //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Storelisting Headername={"Store Listing"} />
            //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
            // case "sm-2":
            //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Inventorymangement Headername={"Inventory Mangement"} />
            //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
            // case "4":
            //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Publicinvlink Headername={"Public Invoice Link"} />
            //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
            // case "5":
            //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Refferalsupport Headername={"Refer Others"} />
            //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
            // case "6":
            //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Digicontact Headername={"Contact Us"} Notshowheader={true} />
            //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
            // case "7":
            //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Websitebuildrform Headername={"Website Builder Form"} />
            //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
            // case "8":
            //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Caservices Headername={"Acccounting Services"} />
            //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
            default:
                return <div>Select an option</div>;
        }
    }

    return (
        <div style={{ display: 'flex', minHeight: '100vh' }}>
            <nav className={"navbar"} style={{
                width: collapsed ? 80 : 260,
                transition: "all .3s ease",
                overflow: "hidden",
            }}>
                <div className={"header"}>
                    <Group justify="space-between">
                        <Image
                            src={Logo}
                            alt="LOGO"
                            preview={false}
                            height={collapsed ? 35 : 50}
                        />

                        {collapsed ? (
                            <IconMenu2
                                size={24}
                                style={{ cursor: "pointer" }}
                                onClick={() => setCollapsed(false)}
                            />
                        ) : (
                            <IconMenuDeep
                                size={24}
                                style={{ cursor: "pointer" }}
                                onClick={() => setCollapsed(true)}
                            />
                        )}
                    </Group>
                </div>

                <ScrollArea className={"links"}>
                    <div className={"linksInner"} style={{ overflow: "hidden", }}>
                        <Menu
                            defaultSelectedKeys={['1']}
                            defaultOpenKeys={['sub1']}
                            mode="inline"
                            inlineCollapsed={collapsed}
                            items={mockdata}
                            onSelect={(e) => setSelectedKey(e.key)} // Update selected key
                        />
                    </div>
                </ScrollArea>


                <div className={"footer"}>
                    <Button size='xs' color='red' variant='light' fullWidth radius={0} rightSection={collapsed ? <IconLogout size={20} /> : <>Logout <IconLogout size={20} style={{ marginLeft: '5px' }} /> </>}></Button>
                </div>
            </nav>
            <div
                style={{
                    flex: 1,
                    // marginLeft: collapsed ? 80 : 260,
                    transition: "all .3s ease",
                    // padding: 5,
                }}
            >
                {renderSelectedItem(selectedKey)}
            </div>
        </div>
    );
}